import { Vue, Component } from 'vue-property-decorator'

@Component
export default class extends Vue {
    scrollTableX = 0

    scrollTableBody: any = null

    scrollingInterval: any = null

    isLeftMouseEnter: boolean = false

    isRightMouseEnter: boolean = false

    scrollBarWidth: number = 1000

    initScrollTable(bodyWrapper) {
        this.scrollTableBody = bodyWrapper
        this.scrollTableBody.addEventListener('scroll', e => {
            this.scrollTableX = e.target.scrollLeft
            const scrollBarEl: any = document.querySelector('.scroll-bar-wrapper')
            if (!scrollBarEl) return
            if (e.target.scrollLeft === 0) {
                scrollBarEl.scrollLeft = 0
            } else if (Math.round(e.target.scrollLeft + e.target.clientWidth) >= e.target.scrollWidth) {
                scrollBarEl.scrollLeft = scrollBarEl.scrollWidth
            } else {
                scrollBarEl.scrollLeft = e.target.scrollLeft
            }
        })
    }

    handleScrollBar(e) {
        if (this.scrollTableBody) {
            if (e.target.scrollLeft === 0) {
                this.scrollTableBody.scrollLeft = 0
            } else if (Math.round(e.target.scrollLeft + e.target.clientWidth) >= e.target.scrollWidth) {
                this.scrollTableBody.scrollLeft = this.scrollTableBody.scrollWidth
            } else {
                this.scrollTableBody.scrollLeft = e.target.scrollLeft
            }
        }
    }

    startTableXScroll(direction) {
        if (this.scrollTableBody) {
            this.scrollBarWidth = this.scrollTableBody.scrollWidth - this.scrollTableBody.clientWidth
            this.scrollingInterval = setInterval(() => {
                if (direction === 'left') {
                    this.isLeftMouseEnter = true
                    this.scrollTableX -= 50
                } else {
                    this.isRightMouseEnter = true
                    this.scrollTableX += 50
                }

                // 边界值判断
                if (this.scrollTableX < 0) this.scrollTableX = 0
                if (this.scrollTableX > this.scrollBarWidth) this.scrollTableX = this.scrollBarWidth

                this.scrollTableBody.scrollLeft = this.scrollTableX
            }, 50)
        }
    }

    clearTableScrollInterval() {
        clearInterval(this.scrollingInterval)
        this.isLeftMouseEnter = false
        this.isRightMouseEnter = false
        this.scrollingInterval = null
    }
}
